function decodeBase64UrlSegment(base64UrlSegment: string): string {
  const base64Segment = base64UrlSegment.replace(/-/g, '+').replace(/_/g, '/');
  const paddingLength = (4 - (base64Segment.length % 4)) % 4;
  const paddedBase64Segment = base64Segment + '='.repeat(paddingLength);
  return window.atob(paddedBase64Segment);
}

export function readTokenExpiryEpochMilliseconds(token: string): number | null {
  const tokenSegments = token.split('.');
  const payloadSegment = tokenSegments[1];
  if (tokenSegments.length !== 3 || payloadSegment === undefined) {
    return null;
  }
  try {
    const decodedPayload: unknown = JSON.parse(decodeBase64UrlSegment(payloadSegment));
    if (typeof decodedPayload !== 'object' || decodedPayload === null) {
      return null;
    }
    const expiryClaim = (decodedPayload as { exp: unknown }).exp;
    if (typeof expiryClaim !== 'number') {
      return null;
    }
    return expiryClaim * 1000;
  } catch {
    return null;
  }
}

export function isTokenExpiringWithin(token: string, thresholdMilliseconds: number): boolean {
  const expiryEpochMilliseconds = readTokenExpiryEpochMilliseconds(token);
  if (expiryEpochMilliseconds === null) {
    return false;
  }
  return expiryEpochMilliseconds - Date.now() <= thresholdMilliseconds;
}
